import { createApp } from 'layout_congress/js/App.mts'

import routes from 'signin/vue/page/signin/routes.mts'
import { createRouter, createWebHistory } from 'vue-router'

const app = createApp({
    template: '<router-view />',
})

const router = createRouter({
  history: createWebHistory(),
  routes,
})
app.use(router)

app.mount('#app')
